import Annotations from '../components/annotation/Annotations'
import AnnotationForm from '../components/annotation/AnnotationForm'
import ActivityLogs from '../components/ActivityLogs'
import ReportIssueForm from '../components/ReportIssueForm'

export default {
	components: {
		'annotations': Annotations,
		'activity-logs': ActivityLogs,
		'report-issue': ReportIssueForm,
	},
	data () {
		return {
			viewer: null,
			activeTab: 'general',
			wikidataSearchFlag: false,
			annotationFormFlag: false,
			annotationSelected: {},
		}
	},
	computed: {
		annotationFormComponent() {
			return AnnotationForm;
		}
	},
	created() {
		document.addEventListener('keyup', this.eventHandler);
    },
	mounted() {
		// Initially display the image when the modal is opened.
		this.openseadragon();
	},
	updated() {
		// Update the image when 'Prev' or 'Next' option is selected.
		if(this.$refs['osd'].childElementCount == 0) {
			this.openseadragon();
		}
	},
	methods: {
		onAnnotationSelected(annotation) {
			this.annotationSelected = annotation;
			this.annotationFormFlag = true;
		},
		hideWikidataSearch() {
			this.wikidataSearchFlag = false;
		},
		resetData() {
			this.wikidataSearchFlag = false;
			this.annotationFormFlag = false;
			this.annotationSelected = {}
			this.destroyOpenseadragon();
		},
		configureOpenseadragon() {
			if(this.viewer !== null) {
				// Disabling shortcut keys.
				this.viewer.innerTracker.keyHandler = null;
				
				// Disabling zoom on click.
				this.viewer.gestureSettingsMouse.clickToZoom = false;
			}
		},
		destroyOpenseadragon() {
			if (this.viewer !== null) {
				this.viewer.destroy();
			}
		},
		hasPrev(dataId) {
			var $prev = this.current(dataId).prev();
			return $prev.length > 0 ? $prev : null;
		},
		prev(dataId) {
			var $prev = this.hasPrev(dataId);
			
			if($prev !== null) {
				var params = $prev.data('id').split('-');
				this.getArtifactById(params[0], parseInt(params[1]));
			}
			
			this.resetData();
		},
		hasNext(dataId) {
			var $next = this.current(dataId).next();
			return $next.length > 0 ? $next : null;
		},
		next(dataId) {
			var $next = this.hasNext(dataId);
			
			if($next !== null) {
				var params = $next.data('id').split('-');
				this.getArtifactById(params[0], parseInt(params[1]));
			}
			
			this.resetData();
		},
		getArtifactById(type, id) {
			if(type === 'image') {
				this.$store.dispatch('GET_IMAGE', {'id': id});
			} else if (type === 'page') {
				this.$store.dispatch('GET_PAGE', {'id': id});
			}
		},
		current(dataId) {
			return $('article.image-result[data-id="' + dataId + '"]');
		},
		// This will live update annotation regions if 'Preview Annotations' is toggled.
		updateAnnotations(artifact, annotations) {
			if(artifact.type === 'image') {
				_.map(this.$store.state.images.data, function(image) { 
					if(artifact.id === image.id) {
						Vue.set(image, 'annotations', annotations);
					}
				});
			} else if (artifact.type === 'page') {
				_.map(this.$store.state.pages.data, function(page) {
					if(artifact.id === page.id) {
						Vue.set(page, 'annotations', annotations);
					}
				});
			}
		},
		eventHandler(event) {
			// If no other dialog/modal is open, handle the 'Esc' key event.
			if (document.getElementsByClassName('modal-dialog').length == 0 && event.keyCode === 27) {
				this.close();
			}
		},
		close() {
			// Display confirmation message if annotation form is open and has 'transcription' or 'tags' entered.
			if(this.annotationFormFlag && typeof this.$refs.annotationForm !== 'undefined'
				&& (this.$refs.annotationForm.annotation.transcription !== ''
					|| this.$refs.annotationForm.annotation.tags.length > 0)) {
				
				// Remove event listener while displaying the confirmation message.
				// So that, the confirmation message won't be displayed multiple times
				// if 'Esc' is clicked again while it's being displayed.
				document.removeEventListener('keyup', this.eventHandler);
				
        		this.$bvModal.msgBoxConfirm(this.__('translations.message.close_modal_without_saving'), {
    				okTitle: this.__('translations.button.yes'),
    				cancelTitle: this.__('translations.button.no'),
    				centered: true,
    				noCloseOnBackdrop: true,
    			}).then(confirmed => {
    				if(confirmed) {
    					this.$emit('close');
    				} else {
    					// Add the event back. So that, it can keep listening.
    					document.addEventListener('keyup', this.eventHandler);
    				}
    			}).catch(err => {
    				// An error occurred
    			})
        	} else {
        		this.$emit('close');
        	}
		}
	},
	beforeDestroy() {
		this.destroyOpenseadragon();
		document.removeEventListener('keyup', this.eventHandler);
	}
}